export default "__VITE_ASSET__DUdAx07D__"